import React from 'react'
import "./Principal.css"
function Principal() {
  return (
    <>
    <div className="principal-hero-section">
      <div className="container">
        <div className="principal-content-wrapper">
          <div className="principal-text-content">
            <p className="principal-role">Managing Director/Sargodha Institute of Health Sciences, Sargodha</p>
            <h1 className="principal-name">Ahmad Mahmood Makhdoom</h1>
            <p className="principal-message-text">
              Physiotherapy is essentially one of the healing sciences which pertain to the assessment of Musculoskeletal and Neurological disorders of function
including pain and those of psychosomatic origin. It also deals with treatment by natural sources, based on movement, manual therapy and other
physical agents to relieve pain, promote healing, prevent or ameliorate deformity, improve function, body health, stimulate or habilitate development
in a child or rehabilitate those impaired by disease or trauma. The responsibilities of Physiotherapist therefore, revolves around the Philosophy
described above i.e., aiming to prevent/cure secondary physical, psychological and social trauma in patients referred to him, through his advice,
education and supportive counselling towards good management., by the virtue of his qualification. Physiotherapist acquires such a vast
knowledge, experience and skill that in the medical profession he is legally and ethically responsible for planning, conducting and evaluating
physiotherapy program for persons or patients. He is responsible for carrying out the Physiotherapy Treatment Program or selective part of it. He is
also responsible to instruct the patients or persons and their families regarding the Physiotherapy Treatment Program and supervise “Physiotherapy Aids, students and other health workers”. Physiotherapy is required in Clinics, Industries and Games. Work of a Physiotherapist includes assessment and evaluation of the patients, prevention of Physical disabilities, deformities, to minimize the complications already occurred or at least
stop them at the level at which it was received and rehabilitate. In hospital, planning the program of physiotherapy, the Physiotherapist reviews the
medical record, evaluates the patients and identifies the patients‟ problems. A Physiotherapist must also keep in mind the views of other members
of medical team
            </p>
            <a href="#full-message" className="read-more-btn">
              READ MORE
            </a>
          </div>

        </div>
      </div>
    </div>

    </>
  )
}

export default Principal